import { SpaceBetween } from '@cloudscape-design/components';
import { FC } from 'react';
import { TiBatteryFull, TiBatteryHigh, TiBatteryLow, TiBatteryMid } from 'react-icons/ti';
import { useNavigate } from 'react-router-dom';
import { iSpindelSample } from '../components/modules/HydroPi';
import { Batch } from '../models/Batch';
import { toDate } from '../utils/timestamp';
import { useModuleTranslation } from '../lang';

interface ISpindelWidgetProps {
  iSpindels: iSpindelSample[];
  batches: Batch[];
}

const ISpindelWidget: FC<ISpindelWidgetProps> = ({ iSpindels, batches }) => {
  const nav = useNavigate();
  const t = useModuleTranslation('ISpindelWidget');
  return (
    <SpaceBetween size="s" direction="vertical">
      {iSpindels.map((sample) => {
        // name is horrible-iSpindel-<color><id> so we need to extract the color
        const colorFromNameAndId = sample.name.split('-')[2];
        const color = colorFromNameAndId.slice(0, -2);

        const batch =
          batches.find(
            (b) =>
              b.hydroPi?.color === sample.color &&
              toDate(b?.hydroPi?.startDate) < toDate(sample.timestamp) &&
              (b?.hydroPi?.startDate?.seconds ?? 0) - (b?.hydroPi?.endDate?.seconds ?? 0) > 0,
          ) ??
          batches.find(
            (b) => b.hydroPi?.color === sample.color && toDate(b?.hydroPi?.startDate) < toDate(sample.timestamp),
          );
        const name = batch?.name ?? color;

        return (
          <div
            key={sample.id}
            className="pointer"
            onClick={() => {
              nav('/batches/' + batch?.id);
            }}
            style={{
              width: '100%',
              height: 56,
              position: 'relative',
              backgroundColor: color,
              borderRadius: 5,
              border: '1px solid grey',
              overflow: 'hidden',
              padding: 5,
              color: color === 'black' ? 'whitesmoke' : 'black',
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: name.length > 10 ? 20 : name.length > 5 ? 24 : 28,
                position: 'absolute',
                top: 5,
                right: 5,
              }}
            >
              {name}
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                top: 5,
                left: 5,
              }}
            >
              {sample.temperature.toFixed(1)}°C
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                bottom: 5,
                left: 5,
              }}
            >
              {sample.gravity.toFixed(3)}
            </div>
            <div
              style={{
                display: 'flex',
                gap: 4,
                fontWeight: 'bold',
                fontSize: 14,
                position: 'absolute',
                bottom: 5,
                right: 5,
                alignItems: 'center',
              }}
            >
              {sample.battery / 0.05 < 50 ? (
                <TiBatteryLow size={28} />
              ) : sample.battery / 0.05 < 75 ? (
                <TiBatteryMid />
              ) : sample.battery / 0.05 < 85 ? (
                <TiBatteryHigh />
              ) : (
                <TiBatteryFull />
              )}{' '}
              {(sample.battery / 0.05).toFixed(0)}%{' '}
            </div>
            {/* sample age, from timestamp (hours ago) */}
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                position: 'absolute',
                top: 5,
                left: '40%',
              }}
            >
              {Math.round((Date.now() - toDate(sample.timestamp).getTime()) / 3600000)} {t.hoursAgo}
            </div>
          </div>
        );
      })}
    </SpaceBetween>
  );
};

export default ISpindelWidget;
